import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import { FaPlus, FaTrash } from 'react-icons/fa';

const CategoryManager = () => {
    const [categories, setCategories] = useState([]);
    const [newCatName, setNewCatName] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            const res = await api.get('/categories');
            setCategories(res.data);
        } catch (err) { toast.error("Failed to load categories"); }
    };

    const handleAddCategory = async (e) => {
        e.preventDefault();
        if(!newCatName.trim()) return;
        setLoading(true);
        try {
            const res = await api.post('/categories', { name: newCatName });
            setCategories([...categories, res.data]);
            setNewCatName('');
            toast.success("Category added");
        } catch (err) { toast.error("Error adding category"); }
        finally { setLoading(false); }
    };

    const handleDelete = async (id) => {
        if(!window.confirm("Delete this category?")) return;
        try {
            await api.delete(`/categories/${id}`);
            setCategories(categories.filter(c => c.id !== id));
            toast.success("Category deleted");
        } catch (err) { toast.error("Delete failed"); }
    };

    return (
        <div style={{maxWidth: '800px'}}>
            <div className="admin-header">
                <h2>Category Management</h2>
            </div>

            <div className="admin-form-container">
                <form onSubmit={handleAddCategory} style={{display:'flex', gap:'15px'}}>
                    <input 
                        type="text" 
                        className="form-control" 
                        placeholder="New Category Name" 
                        value={newCatName}
                        onChange={(e) => setNewCatName(e.target.value)}
                    />
                    <button type="submit" className="admin-btn" disabled={loading}>
                        <FaPlus /> Add
                    </button>
                </form>
            </div>

            <table className="admin-table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {categories.map(cat => (
                        <tr key={cat.id}>
                            <td>{cat.id}</td>
                            <td>{cat.name}</td>
                            <td>
                                <button className="action-btn delete-btn" onClick={() => handleDelete(cat.id)}>
                                    <FaTrash /> Delete
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default CategoryManager;